// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';

// Helper to transform legacy form values to DynamicContent format
const transformToDynamic = (values, fieldName) => {
  return {
    es: values[fieldName] || '',
    en: values[`${fieldName}_en`] || '',
    fr: values[`${fieldName}_fr`] || '',
    it: values[`${fieldName}_it`] || '',
    pt: values[`${fieldName}_pt`] || '',
  };
};

async function submit(values, dispatch) {
  // Build the GraphQL mutation for DynamicContent
  const query = `
    mutation updateCancellationPolicyDynamic(
      $policyType: String!,
      $contentOne: PolicyFieldInput,
      $contentTwo: PolicyFieldInput,
      $beforeDaysTitle: PolicyFieldInput,
      $beforeDaysContentOne: PolicyFieldInput,
      $beforeDaysContentTwo: PolicyFieldInput,
      $checkInTitle: PolicyFieldInput,
      $checkInContentOne: PolicyFieldInput,
      $checkInContentTwo: PolicyFieldInput,
      $checkOutTitle: PolicyFieldInput,
      $checkOutContentOne: PolicyFieldInput,
      $checkOutContentTwo: PolicyFieldInput
    ) {
      updateCancellationPolicyDynamic(
        policyType: $policyType,
        contentOne: $contentOne,
        contentTwo: $contentTwo,
        beforeDaysTitle: $beforeDaysTitle,
        beforeDaysContentOne: $beforeDaysContentOne,
        beforeDaysContentTwo: $beforeDaysContentTwo,
        checkInTitle: $checkInTitle,
        checkInContentOne: $checkInContentOne,
        checkInContentTwo: $checkInContentTwo,
        checkOutTitle: $checkOutTitle,
        checkOutContentOne: $checkOutContentOne,
        checkOutContentTwo: $checkOutContentTwo
      ) {
        status
        message
      }
    }
  `;

  // Transform form values to DynamicContent format
  const variables = {
    policyType: values.policyType,
    contentOne: transformToDynamic(values, 'contentOne'),
    contentTwo: transformToDynamic(values, 'contentTwo'),
    beforeDaysTitle: transformToDynamic(values, 'beforeDaysTitle'),
    beforeDaysContentOne: transformToDynamic(values, 'beforeDaysContentOne'),
    beforeDaysContentTwo: transformToDynamic(values, 'beforeDaysContentTwo'),
    checkInTitle: transformToDynamic(values, 'checkInTitle'),
    checkInContentOne: transformToDynamic(values, 'checkInContentOne'),
    checkInContentTwo: transformToDynamic(values, 'checkInContentTwo'),
    checkOutTitle: transformToDynamic(values, 'checkOutTitle'),
    checkOutContentOne: transformToDynamic(values, 'checkOutContentOne'),
    checkOutContentTwo: transformToDynamic(values, 'checkOutContentTwo'),
  };

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: variables
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateCancellationPolicyDynamic.status === "success") {
    showToaster({ messageId: 'updateSuccess', toasterType: 'success' });
  } else {
    showToaster({ messageId: 'updateFailed', toasterType: 'error' });
  }
}

export default submit;
